export default __webpack_public_path__ + "static/Solcast-e78558b5f98dfa57b5f7d3b8b3bd7bb4.png";